import React from "react";

import "./auth.css";

import Button from "app/components/button/Button";
// import ThemeSwitcher from "app/styles/theme/ThemeSwitcher";
import LanguageSwitcher from "app/translations/LanguageSwitcher";
import { StoreContext } from "app/context/Store";
import { DOWNLOAD_IMAGE } from "app/api/ApiEndpoints";

function ResetPassword() {
  const { state } = React.useContext(StoreContext);
  const heading = "One Gateway, Many Solutions";

  return (
    <>
      <div className="login-wrapper">
        <div className="row no-gutters">
          {/* <Fade left big> */}
          <div className="col-md-6">
            <div className="left_side">
              <h1 className="banner_head text-uppercase"> {heading} </h1>

              <div style={{ position: "absolute", bottom: "10px" }}>
                {/* <ThemeSwitcher /> */}
                <LanguageSwitcher />
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="right_side">
              <div className="text-center">
                <img
                  src={DOWNLOAD_IMAGE +'?key='+ state?.clientConfigData?.logo}
                  alt="client-logo"
                  className="h-15"
                />
              </div>
              <div id="login-form">
                <h2 className="text-center py-4 ">Reset Password</h2>

                <form action="">
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter your New Password"
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm your New Password"
                    />
                  </div>

                  <div className="clearfix"></div>

                  <Button className="button btn-primary">Submit</Button>
                </form>
              </div>
              {/* </Pulse> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
